import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import { ROLE_AR, isAdmin } from '../utils/roles';

export default function Users() {
  const { api, user: currentUser } = useAuth();
  const toast = useToast();
  const canCreate = isAdmin(currentUser);
  const canChangeRole = isAdmin(currentUser);

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [form, setForm] = useState({ name: '', email: '', password: '123456', role: 'team', permissions_mode: 'role', permissions: [], project_scoped: false });
  const [catalog, setCatalog] = useState(null);

  const load = () => api('/users').then(setUsers).catch(() => {}).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);
  useEffect(() => {
    if (showModal && !catalog) {
      api('/permissions/catalog').then(setCatalog).catch(() => {});
    }
  }, [showModal, catalog]);

  const openCreate = () => {
    setEditingUser(null);
    setForm({ name: '', email: '', password: '123456', role: 'team', permissions_mode: 'role', permissions: [], project_scoped: false });
    setShowModal(true);
  };

  const openEdit = (u) => {
    setEditingUser(u);
    setForm({
      name: u.name,
      email: u.email,
      password: '',
      role: u.role,
      permissions_mode: u.permissions_mode || 'role',
      permissions: Array.isArray(u.permissions) ? u.permissions : (Array.isArray(u.effective_permissions) ? u.effective_permissions : []),
      project_scoped: !!u.project_scoped,
    });
    setShowModal(true);
  };

  const togglePerm = (key) => {
    setForm(f => ({
      ...f,
      permissions: f.permissions.includes(key) ? f.permissions.filter(k => k !== key) : [...f.permissions, key],
    }));
  };

  const applyPreset = (role) => {
    if (!catalog) return;
    setForm(f => ({ ...f, permissions: [...(catalog.presets?.[role] || [])] }));
  };

  const save = async () => {
    try {
      const base = canChangeRole
        ? { name: form.name, email: form.email, role: form.role, permissions_mode: form.permissions_mode, project_scoped: form.project_scoped }
        : { name: form.name, email: form.email };
      if (canChangeRole && form.permissions_mode === 'custom') {
        base.permissions = form.permissions;
      }
      if (editingUser) {
        await api(`/users/${editingUser.id}`, { method: 'PUT', body: JSON.stringify(base) });
        toast.success('تم تحديث المستخدم');
      } else {
        const payload = { ...base, password: form.password };
        await api('/users', { method: 'POST', body: JSON.stringify(payload) });
        toast.success('تم إنشاء المستخدم');
      }
      setShowModal(false);
      load();
    } catch (err) { toast.error(err.message); }
  };

  const toggleActive = async (u) => {
    try {
      await api(`/users/${u.id}`, { method: 'PUT', body: JSON.stringify({ is_active: !u.is_active }) });
      load();
    } catch (err) { toast.error(err.message); }
  };

  const resetPass = async (u) => {
    const pw = prompt('كلمة المرور الجديدة:', '123456');
    if (!pw) return;
    try {
      await api(`/users/${u.id}/reset-password`, { method: 'POST', body: JSON.stringify({ password: pw }) });
      toast.success('تم إعادة تعيين كلمة المرور');
    } catch (err) { toast.error(err.message); }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <h2>المستخدمون</h2>
        {canCreate && (
          <button className="btn btn-primary" data-tour="users-create" onClick={openCreate}>+ مستخدم جديد</button>
        )}
      </div>
      <div className="card">
        {loading ? <div className="loader">جاري التحميل...</div> : (
          <div className="table-wrap">
            <table>
              <thead><tr><th>الاسم</th><th>البريد</th><th>الدور</th><th>الحالة</th><th>إجراءات</th></tr></thead>
              <tbody>
                {users.map(u => (
                  <tr key={u.id}>
                    <td style={{ fontWeight: 500 }}>{u.name}</td>
                    <td style={{ direction: 'ltr', textAlign: 'right' }}>{u.email}</td>
                    <td>
                      <span className={`badge badge-${u.role === 'admin' ? 'approved' : u.role === 'supervisor' ? 'waiting_approval' : u.role === 'team' ? 'in_progress' : 'pending'}`}>
                        {ROLE_AR[u.role] || u.role}
                      </span>
                    </td>
                    <td><span className={`badge ${u.is_active ? 'badge-completed' : 'badge-cancelled'}`}>{u.is_active ? 'نشط' : 'معطل'}</span></td>
                    <td style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                      <button className="btn btn-sm btn-outline" onClick={() => openEdit(u)}>تعديل</button>
                      <button className="btn btn-sm btn-outline" onClick={() => toggleActive(u)}>{u.is_active ? 'تعطيل' : 'تفعيل'}</button>
                      <button className="btn btn-sm btn-outline" onClick={() => resetPass(u)}>إعادة كلمة المرور</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-title">{editingUser ? `تعديل: ${editingUser.name}` : 'مستخدم جديد'}</div>
            <div className="form-group"><label className="form-label">الاسم</label><input className="form-input" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} /></div>
            <div className="form-group"><label className="form-label">البريد</label><input className="form-input" type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} /></div>
            <div className="form-row">
              {!editingUser && (
                <div className="form-group"><label className="form-label">كلمة المرور</label><input className="form-input" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} /></div>
              )}
              <div className="form-group">
                <label className="form-label">الدور</label>
                <select className="form-select" value={form.role} disabled={editingUser && !canChangeRole} onChange={e => setForm(f => ({ ...f, role: e.target.value }))}>
                  <option value="team">عضو فريق</option>
                  <option value="supervisor">مشرف</option>
                  <option value="admin">إدارة</option>
                  <option value="client">عميل</option>
                </select>
                {editingUser && !canChangeRole && (
                  <small style={{ color: 'var(--text-faint)' }}>تغيير الدور صلاحية إدارة فقط</small>
                )}
              </div>
            </div>
            {canChangeRole && ['supervisor', 'team'].includes(form.role) && (
              <div className="form-group">
                <label style={{ display: 'flex', gap: 8, alignItems: 'center', cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    checked={form.project_scoped}
                    onChange={e => setForm(f => ({ ...f, project_scoped: e.target.checked }))}
                  />
                  <span>مقيَّد بالمشاريع المسندة</span>
                </label>
                <small style={{ color: 'var(--text-faint)' }}>
                  عند التفعيل، يرى المستخدم فقط المشاريع التي هو عضو في فريقها وما يرتبط بها (المهام، العملاء، الفواتير).
                </small>
              </div>
            )}
            {canChangeRole && (
              <div className="form-group">
                <label className="form-label">نمط الصلاحيات</label>
                <div style={{ display: 'flex', gap: 12, marginBottom: 8 }}>
                  <label style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                    <input type="radio" name="permMode" checked={form.permissions_mode === 'role'} onChange={() => setForm(f => ({ ...f, permissions_mode: 'role' }))} />
                    صلاحيات الدور (جاهز)
                  </label>
                  <label style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
                    <input type="radio" name="permMode" checked={form.permissions_mode === 'custom'} onChange={() => setForm(f => ({ ...f, permissions_mode: 'custom', permissions: f.permissions.length ? f.permissions : (catalog?.presets?.[f.role] || []) }))} />
                    مخصّص
                  </label>
                </div>
                {form.permissions_mode === 'custom' && (
                  <div style={{ border: '1px solid var(--border)', borderRadius: 6, padding: 12, maxHeight: 320, overflowY: 'auto' }}>
                    <div style={{ display: 'flex', gap: 6, marginBottom: 10, flexWrap: 'wrap' }}>
                      <small style={{ color: 'var(--text-faint)', alignSelf: 'center' }}>تطبيق قالب:</small>
                      <button type="button" className="btn btn-sm btn-outline" onClick={() => applyPreset('admin')}>إدارة</button>
                      <button type="button" className="btn btn-sm btn-outline" onClick={() => applyPreset('supervisor')}>مشرف</button>
                      <button type="button" className="btn btn-sm btn-outline" onClick={() => applyPreset('team')}>فريق</button>
                      <button type="button" className="btn btn-sm btn-outline" onClick={() => setForm(f => ({ ...f, permissions: [] }))}>تفريغ</button>
                    </div>
                    {catalog ? Object.entries(catalog.catalog).map(([gKey, group]) => (
                      <div key={gKey} style={{ marginBottom: 10 }}>
                        <div style={{ fontWeight: 600, marginBottom: 4 }}>{group.label}</div>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 3, paddingInlineStart: 8 }}>
                          {Object.entries(group.items).map(([key, label]) => (
                            <label key={key} style={{ display: 'flex', gap: 6, alignItems: 'center', fontSize: 13 }}>
                              <input type="checkbox" checked={form.permissions.includes(key)} onChange={() => togglePerm(key)} />
                              {label}
                            </label>
                          ))}
                        </div>
                      </div>
                    )) : <small style={{ color: 'var(--text-faint)' }}>جاري تحميل الصلاحيات...</small>}
                  </div>
                )}
              </div>
            )}
            <div className="modal-actions">
              <button className="btn btn-primary" onClick={save} disabled={!form.name || !form.email}>{editingUser ? 'حفظ' : 'إنشاء'}</button>
              <button className="btn btn-outline" onClick={() => setShowModal(false)}>إلغاء</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
